import { CriterionFilters } from "@bundles/parts/data/model"
import { Box, Typography, IconButton, Icon } from "@tm/components"

type CriteriaMenuItemProps = {
    filter: CriterionFilters
    onRemoveSelectedCriteria: (filter: CriterionFilters) => void
}

export function BestsellerCriteria(props: CriteriaMenuItemProps) {
    const { filter, onRemoveSelectedCriteria } = props

    const handleMouseDown = (e: React.MouseEvent) => {
        e.stopPropagation()
        onRemoveSelectedCriteria(filter)
    }

    return (
        <Box display="flex" justifyContent="space-between" width="100%">
            <Typography maxLines={1}>{filter.name}</Typography>
            {filter.isSelected && (
                <IconButton onMouseDown={handleMouseDown} sx={{ padding: 0, opacity: 0.7 }} size="auto">
                    <Icon sx={{ fontSize: "18px" }} name="close" />
                </IconButton>
            )}
        </Box>
    )
}
